/** One simple line icon per industry, for menus and industry pages. */

const PATHS: Record<string, string> = {
  hvac: 'M12 3v18 M4.2 7.5l15.6 9 M4.2 16.5l15.6-9 M9.5 4.5 12 6l2.5-1.5 M9.5 19.5 12 18l2.5 1.5',
  construction: 'M6 21V4 M3 21h8 M6 4h14 M6 4 3 7h3 M9 4l-3 4 M17 4v5 M15 9h4v3h-4z M6 12l3-3',
  solar: 'M12 3v2 M12 19v2 M5 5l1.4 1.4 M17.6 17.6 19 19 M3 12h2 M19 12h2 M5 19l1.4-1.4 M17.6 6.4 19 5 M8 12a4 4 0 1 0 8 0 4 4 0 1 0-8 0',
  'home-services': 'M3 11.5 12 4l9 7.5 M5.5 9.5V20h13V9.5 M10 20v-5h4v5',
  legal: 'M12 4v16 M7 20h10 M5 7h14 M5 7l-3 6a3 3 0 0 0 6 0Z M19 7l-3 6a3 3 0 0 0 6 0Z',
  medical: 'M10 4h4v6h6v4h-6v6h-4v-6H4v-4h6Z',
  franchise: 'M4 9h16l-1.5-4h-13Z M4 9a2.7 2.7 0 0 0 5.3 0 2.7 2.7 0 0 0 5.4 0 2.7 2.7 0 0 0 5.3 0 M5.5 11.5V20h13v-8.5 M10 20v-4h4v4',
  'multi-location': 'M8 21s-5-4.6-5-9a5 5 0 0 1 10 0c0 4.4-5 9-5 9Z M8 12h.01 M17 15s-3.5-3.2-3.5-6.2a3.5 3.5 0 0 1 7 0c0 3-3.5 6.2-3.5 6.2Z',
  'healthcare-systems': 'M4 21V8l8-4 8 4v13 M4 21h16 M12 9v6 M9 12h6 M9.5 21v-3h5v3',
  'service-businesses': 'M4 7h16v13H4z M9 7V4h6v3 M4 12h16 M11 12v2h2v-2',
};

export function IndustryIcon({ slug, className = '' }: { slug: string; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      <path d={PATHS[slug] ?? PATHS['service-businesses']} />
    </svg>
  );
}
